<div class="full-width certn-info" data-test="fix-now-banner" data-testid="carrier-upload-info">
  <div class="content" >
    <div  class="requesting-permission">
      <div>
        <img class="badge" src="../../../assets/images/clearnce_badge.png" />
      </div>
      <div>
        <img class="complete-profile" src="../../../assets/images/complete-profile.png" />
      </div>
    </div>
    <div class="document-info"  data-test="requested-document-name" data-testid="requested-document-name">
      <p>
        We need additional information before we process your
        <span class="document-name" data-test="document-type" data-testid="document-type">{{ documentType }}</span>
      </p>
    </div>
    <div  class="button-info">
      <button
        mat-raised-button
        type="button"
        class="proceed-button full-width"
        (click)="proceed()"
        data-test="proceed-button"
        data-testid="proceed-button"
      >
        Proceed
      </button>
    </div>
  </div>
</div>
